

































































































































import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    disableOperate: {
      requred: true,
      type: Object,
      default: {},
    },
  },
  components: {},
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const methods = {
      showAssociateDialog(type: string) {
        context.emit('showAssociateDialog', type);
      },
      onClose() {
        innerShow.value = false;
      },
    };

    return {
      innerShow,
      ...methods,
    };
  },
});
